import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Componente que detecta tokens de recuperacao de senha na URL
// e redireciona para a pagina de redefinicao de senha
export default function AuthRedirectHandler({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // A pagina /nova-senha cuida do proprio link de recuperacao.
    // Sem esta linha, o link enviado as usuarias seria sequestrado
    // para a tela de redefinicao do painel administrativo.
    if (location.pathname === "/nova-senha") return;

    // Verificar se tem token de recuperacao na URL (hash ou query)
    const hash = window.location.hash;
    const search = window.location.search;

    // O Supabase envia o token no hash como: #access_token=xxx&type=recovery
    if (hash && hash.includes("access_token") && hash.includes("type=recovery")) {
      // Redirecionar para pagina de redefinicao mantendo o hash
      navigate("/acesso-interno-bt/redefinir-senha" + hash, { replace: true });
      return;
    }

    // Tambem verificar na query string (alguns casos)
    if (search && search.includes("access_token") && search.includes("type=recovery")) {
      navigate("/acesso-interno-bt/redefinir-senha" + search, { replace: true });
      return;
    }
  }, [location, navigate]);

  return children;
}
